import { render, staticRenderFns } from "./RegisterRestaurant.vue?vue&type=template&id=545d8808"
import script from "./RegisterRestaurant.vue?vue&type=script&lang=js"
export * from "./RegisterRestaurant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports